import script from "./CodesSearchBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./CodesSearchBar.vue?vue&type=script&lang=ts&setup=true"

import "./CodesSearchBar.vue?vue&type=style&index=0&id=2cf5194e&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSpace,QTooltip,QBtn,QIcon,QField});
